module.exports = __webpack_public_path__ + "img/crm2_3.1d4f08ec.png";